import React, { Dispatch, SetStateAction, useEffect, useState } from "react";
import logo from "../assets/icons/black full logo.svg";
import cover from "../assets/images/Rectangle 18156.png";
import SearchBar from "../components/SearchBar";
import user from "../assets/images/user.png";
import { BsArrowReturnRight } from "react-icons/bs";
import fb from "../assets/icons/facebook.svg";
import insta from "../assets/icons/insta.svg";
import youtube from "../assets/icons/YT.svg";
import radioNonCheckedIcon from "../assets/icons/RadioNonCheckedIcon.svg";
import radioCheckedBoxIcon from "../assets/icons/RadioCheckedBoxIcon.svg";
import { PiTranslateBold } from 'react-icons/pi';
import Button from "../components/Button";
import PrimaryButton from "../components/PrimaryButton";
import AdjustmentModal from "../components/AdjustmentModal";
import { useRedirect } from "../hooks/useRedirect";
import pathnames from "../routes/index.route";
import { RxCross2 } from "react-icons/rx";
import Circlebtn from "../components/Circlebtn";
import uk from "../assets/icons/uk.svg";
import ind from "../assets/icons/india.svg";
import mol from "../assets/icons/moldova.svg";
import GroupFileCard from "../components/GroupFileCard";
import SelectField from "../components/SelectField";
import SelectOption from "../components/SelectOption";
import { InputField } from "../components/InputField";
import TextArea from "antd/es/input/TextArea";

const Account = ({ selected, setSelected }: { selected?: boolean, setSelected?: Dispatch<SetStateAction<boolean>> }) => {
  const [check, setCheck] = useState<boolean>(false);
  useEffect(() => {
    if (selected) {
      setCheck(true);
    } else {
      setCheck(false);
    }
  }, [selected])
  return (
    <div onClick={() => setCheck(!check)} className="flex items-center justify-between cursor-pointer mb-3">
      <div className="flex items-center gap-2">
        <div className="flex items-center">
          <img src={fb} className="w-4 h-4 rounded-full" alt="fb" />
          <img src={user} className="w-4 h-4 rounded-full -ml-1.5" alt="fb" />
        </div>
        <p className="text-[#0F0C18] text-xs font-medium tracking-tight">@andrew wack_en</p>
      </div>
      <div className="flex items-center gap-2">
        <PiTranslateBold className="w-4 h-4 ml-3 text-[#0F0C18]" />
        <p className="text-[#9392A2] text-xs font-medium tracking-tight">English</p>
        <img className="cursor-pointer" src={check ? radioCheckedBoxIcon : radioNonCheckedIcon} alt="radioNonCheckedIcon" />
      </div>
    </div>
  );
}

const Groups = () => {
  const [selected, setSelected] = useState<boolean>(false);
  return (
    <div className="p-3 bg-white rounded-xl mb-3">
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-2.5">
          <img src={user} className="w-10 h-10 rounded-full" alt="workspace" />
          <div>
            <div className="text-[#0F0C18] text-base font-medium tracking-tight">Andrew Wack</div>
            <div className="text-[#9392A2] text-xs font-medium tracking-tight">3 accounts under</div>
          </div>
        </div>
        <img onClick={() => setSelected(!selected)} className="cursor-pointer" src={selected ? radioCheckedBoxIcon : radioNonCheckedIcon} alt="radioNonCheckedIcon" />
      </div>
      <div className="mt-3.5 flex items-start gap-[22px]">
        <BsArrowReturnRight className="w-4 h-4 ml-3 text-[#9392A2]" />
        <div className="w-full">
          {
            [...Array(3)].map((_, index) => <Account key={index} selected={selected} setSelected={setSelected} />)
          }
        </div>
      </div>
    </div>
  );
}

const ChooseAccounts = ({ setPageIndex }: { setPageIndex?: Dispatch<SetStateAction<number>> }) => {
  return (
    <>
      <p className="text-[#0F0C18] text-[28px] font-medium mt-1 tracking-tight">Choose accounts</p>
      <p className="text-[#9392A2] text-sm font-medium leading-snug tracking-tight">Please select accounts under one group in terms<br />of languages you selected</p>
      <SearchBar className="bg-white w-[391px] rounded-full text-xs my-4" inputCss="bg-white" placeholder="Search files and groups" />
      {
        [...Array(3)].map((_, index) => <Groups key={index} />)
      }
      <Button onClick={() => setPageIndex && setPageIndex(page => page + 1)} className="absolute bottom-5 w-[380px] py-2.5" label="Proceed" />
    </>
  );
}

const Adjustment = ({ setPageIndex }: { setPageIndex?: Dispatch<SetStateAction<number>> }) => {
  return (
    <>
      <p className="text-[#0F0C18] text-[28px] font-medium mt-1 tracking-tight">Adjustment</p>
      <AdjustmentModal buttons={false} thumbnail />
      <div className="flex items-center gap-2 absolute bottom-5 w-[380px]">
        <PrimaryButton onClick={() => setPageIndex && setPageIndex(page => page - 1)} label="Back" className="py-2 w-full rounded-3xl" black />
        <PrimaryButton onClick={() => setPageIndex && setPageIndex(page => page + 1)} label="Confirm" className="py-2 w-full rounded-3xl" />
      </div>
    </>
  );
}

const FillUpTheData = ({ setPageIndex }: { setPageIndex?: Dispatch<SetStateAction<number>> }) => {
  return (
    <>
      <p className="text-[#0F0C18] text-[28px] font-medium mt-1 tracking-tight">Fill up the data</p>
      <div className="flex items-center gap-2 mt-2 mb-3 flex-wrap">
        <div className="flex items-center gap-2 bg-white p-2 rounded-3xl">
          <img className="w-4 h-4 rounded-full" src={uk} alt="uk" />
          <p className="text-[#0F0C18] text-sm font-medium tracking-tight">English</p>
        </div>
        <div className="flex items-center gap-2 border border-[#CDCCD7] p-2 rounded-3xl">
          <img className="w-4 h-4 rounded-full" src={ind} alt="uk" />
          <p className="text-[#0F0C18] text-sm font-medium tracking-tight">Hindi</p>
        </div>
        <div className="flex items-center gap-2 border border-[#CDCCD7] p-2 rounded-3xl">
          <img className="w-4 h-4 rounded-full" src={mol} alt="uk" />
          <p className="text-[#0F0C18] text-sm font-medium tracking-tight">Moldovian</p>
        </div>
      </div>
      <p className="text-[#0F0C18] text-base font-medium tracking-tight mt-4">Posts</p>
      <div className="flex items-center gap-2 mt-1 mb-3 flex-wrap">
        <div className="flex items-center gap-2 bg-white p-2 rounded-3xl">
          <img className="w-4 h-4 rounded-full" src={cover} alt="uk" />
          <p className="text-[#0F0C18] text-sm font-medium tracking-tight">Game video</p>
        </div>
        <div className="flex items-center gap-2 border border-[#CDCCD7] p-2 rounded-3xl">
          <img className="w-4 h-4 rounded-full" src={cover} alt="uk" />
          <p className="text-[#0F0C18] text-sm font-medium tracking-tight">Travel video</p>
        </div>
      </div>
      <GroupFileCard />
      <p className="text-[#0F0C18] text-base font-medium tracking-tight mt-4 mb-1">Accounts</p>
      <p className="text-[#9392A2] text-xs font-medium tracking-tight mb-1">Platforms</p>
      <div className="flex items-center gap-2 mt-2 mb-3 flex-wrap">
        <div className="flex items-center gap-2 bg-white p-2 rounded-3xl">
          <img className="w-4 h-4 rounded-full" src={insta} alt="uk" />
          <p className="text-[#0F0C18] text-sm font-medium tracking-tight">Instagram</p>
        </div>
        <div className="flex items-center gap-2 border border-[#CDCCD7] p-2 rounded-3xl">
          <img className="w-4 h-4 rounded-full" src={youtube} alt="uk" />
          <p className="text-[#0F0C18] text-sm font-medium tracking-tight">YouTube</p>
        </div>
        <div className="flex items-center gap-2 border border-[#CDCCD7] p-2 rounded-3xl">
          <img className="w-4 h-4 rounded-full" src={fb} alt="uk" />
          <p className="text-[#0F0C18] text-sm font-medium tracking-tight">Facebook</p>
        </div>
      </div>
      <p className="text-[#9392A2] text-xs font-medium tracking-tight mt-4 mb-1">Accounts</p>
      <div className="flex items-center gap-2 mt-2 mb-3 flex-wrap">
        <div className="flex items-center gap-2 bg-white p-2 rounded-3xl">
          <div className="flex items-center">
            <img src={insta} className="w-4 h-4 rounded-full" alt="fb" />
            <img src={user} className="w-4 h-4 rounded-full -ml-1.5" alt="fb" />
          </div>
          <p className="text-[#0F0C18] text-sm font-medium tracking-tight">@andrew_wack</p>
        </div>
      </div>
      <p className="text-[#9392A2] text-xs font-medium tracking-tight mt-4 mb-2">Date & time</p>
      <SelectField type="date" label="Date" />
      <SelectOption className="my-2" label="Time" options={["22:00", "23:00", "00:00"]} />
      <p className="text-[#9392A2] text-xs font-medium tracking-tight mt-4 mb-2">Thumbnail</p>
      <div className="bg-white rounded-xl px-2 py-3">
        <div className="text-center text-[#0F0C18] text-base font-medium font-['SF Pro Display'] tracking-tight">Custom thumbnail</div>
        <div className="text-center text-[#9392A2] py-1 mb-2 text-xs font-medium font-['SF Pro Display'] leading-[18px] tracking-tight">Make a custom thumbnail for your video.<br />If you do not upload it, YouTube will make it.</div>
        <PrimaryButton label="Upload thumbnail" black className="w-full rounded-3xl py-2.5" />
      </div>
      <p className="text-[#9392A2] text-xs font-medium tracking-tight mt-4 mb-1">Information</p>
      <InputField label="Title" />
      <TextArea placeholder="Description" className="mt-2" autoSize={{ minRows: 5 }} />
      <TextArea placeholder="Tags" className="mt-2" autoSize={{ minRows: 5 }} />
      <div className="flex items-center gap-2 absolute bottom-5 w-[380px]">
        <PrimaryButton onClick={() => setPageIndex && setPageIndex(page => page - 1)} label="Back" className="py-2 w-full rounded-3xl" black />
        <PrimaryButton onClick={() => setPageIndex && setPageIndex(page => page + 1)} label="Confirm" className="py-2 w-full rounded-3xl" />
      </div>
    </>
  );
}

const PreviewAndConfirm = ({ setPageIndex }: { setPageIndex?: Dispatch<SetStateAction<number>> }) => {
  const redirect = useRedirect();
  return (
    <>
      <p className="text-[#0F0C18] text-[28px] font-medium mt-1 tracking-tight">Preview & confirm</p>

      <p className="text-[#9392A2] text-xs font-medium tracking-tight mt-2 mb-2">Accounts it will be posted</p>
      <div className="flex items-center gap-2 mt-1 mb-3 flex-wrap">
        <div className="flex items-center gap-2 bg-white p-2 rounded-3xl">
          <img className="w-4 h-4 rounded-full" src={cover} alt="uk" />
          <p className="text-[#0F0C18] text-sm font-medium tracking-tight">Game video</p>
        </div>
        <div className="flex items-center gap-2 border border-[#CDCCD7] p-2 rounded-3xl">
          <img className="w-4 h-4 rounded-full" src={cover} alt="uk" />
          <p className="text-[#0F0C18] text-sm font-medium tracking-tight">Travel video</p>
        </div>
      </div>
      <p className="text-[#9392A2] text-xs font-medium tracking-tight mt-4 mb-1">Accounts it will be posted</p>
      <div className="flex items-center gap-2 mt-2 mb-3 flex-wrap">
        <div className="flex items-center gap-2  border border-[#CDCCD7] p-2 rounded-3xl">
          <div className="flex items-center">
            <img src={insta} className="w-4 h-4 rounded-full" alt="fb" />
            <img src={user} className="w-4 h-4 rounded-full -ml-1.5" alt="fb" />
          </div>
          <p className="text-[#0F0C18] text-sm font-medium tracking-tight">@andrew_wack</p>
        </div>
        <div className="flex items-center gap-2 border border-[#CDCCD7] p-2 rounded-3xl">
          <div className="flex items-center">
            <img src={insta} className="w-4 h-4 rounded-full" alt="fb" />
            <img src={user} className="w-4 h-4 rounded-full -ml-1.5" alt="fb" />
          </div>
          <p className="text-[#0F0C18] text-sm font-medium tracking-tight">@andrew wack_sp</p>
        </div>
        <div className="flex items-center gap-2 border border-[#CDCCD7] p-2 rounded-3xl">
          <div className="flex items-center">
            <img src={insta} className="w-4 h-4 rounded-full" alt="fb" />
            <img src={user} className="w-4 h-4 rounded-full -ml-1.5" alt="fb" />
          </div>
          <p className="text-[#0F0C18] text-sm font-medium tracking-tight">@andrew_wack</p>
        </div>
      </div>
      <p className="text-[#9392A2] text-xs font-medium tracking-tight mt-4 mb-1">Languages</p>
      <div className="flex items-center gap-2 mt-2 mb-3 flex-wrap">
        <div className="flex items-center gap-2  border border-[#CDCCD7] p-2 rounded-3xl">
          <img className="w-4 h-4 rounded-full" src={uk} alt="uk" />
          <p className="text-[#0F0C18] text-sm font-medium tracking-tight">English</p>
        </div>
        <div className="flex items-center gap-2 border border-[#CDCCD7] p-2 rounded-3xl">
          <img className="w-4 h-4 rounded-full" src={ind} alt="uk" />
          <p className="text-[#0F0C18] text-sm font-medium tracking-tight">Hindi</p>
        </div>
        <div className="flex items-center gap-2 border border-[#CDCCD7] p-2 rounded-3xl">
          <img className="w-4 h-4 rounded-full" src={mol} alt="uk" />
          <p className="text-[#0F0C18] text-sm font-medium tracking-tight">Moldovian</p>
        </div>
      </div>
      <p className="text-[#9392A2] text-xs font-medium tracking-tight mt-4 mb-1">Video name</p>
      <p className="text-[#0F0C18] text-sm font-medium tracking-tight">@andrew_wack</p>
      <p className="text-[#9392A2] text-xs font-medium tracking-tight mt-4 mb-1">Date & time</p>
      <p className="text-[#0F0C18] text-sm font-medium tracking-tight">September 17, 2021 • 8:00pm</p>
      <p className="text-[#9392A2] text-xs font-medium tracking-tight mt-4 mb-1">Description</p>
      <p className="text-[#0F0C18] text-sm font-medium tracking-tight">That’s my first video for this time <br />
        please write me some nice comments <br />
        because I need your support.</p>
      <p className="text-[#9392A2] text-xs font-medium tracking-tight mt-4 mb-1">Tags</p>
      <p className="text-[#0F0C18] text-sm font-medium tracking-tight">#wow #first #first</p>
      <div className="flex items-center justify-between mt-8">
        <p className="text-[#9392A2] text-xs font-medium tracking-tight">Cost per one video / 1$ = 1min</p>
        <p className="text-[#0F0C18] text-sm font-medium tracking-tight">$ 15.23</p>
      </div>
      <div className="flex items-center justify-between mt-1">
        <p className="text-[#9392A2] text-xs font-medium tracking-tight">Amount for existing translations</p>
        <p className="text-[#9392A2] text-sm font-medium tracking-tight">– $ 25.72</p>
      </div>
      <div className="flex items-center justify-between">
        <p className="text-[#9392A2] text-xs font-medium tracking-tight">Left over amount / 3 videos * $15.23</p>
        <p className="text-[#0F0C18] text-lg font-medium tracking-tight">$ 19.97</p>
      </div>
      <div className="flex items-center gap-2 absolute bottom-5 w-[380px]">
        <PrimaryButton onClick={() => setPageIndex && setPageIndex(page => page - 1)} label="Back" className="py-2 w-full rounded-3xl" black />
        <PrimaryButton onClick={() => redirect(pathnames.accounts)} label="Confirm" className="py-2 w-full rounded-3xl" />
      </div>
    </>
  );
}

const SchedulePublish = () => {
  const [pageIndex, setPageIndex] = useState<number>(1);
  const redirect = useRedirect();
  return (
    <section className="flex overflow-hidden">
      <div className="w-full h-screen bg-[#EAE9EF] relative">
        <img onClick={() => redirect(pathnames.home)} className="absolute top-3 left-3 cursor-pointer" src={logo} alt="logo" />
        <div className="flex justify-center overflow-auto no-scrollbar">
          <div className="w-[380px] h-screen">
            <p className="text-[#9392A2] text-xs font-medium tracking-tight mt-20">Step {pageIndex} of 4</p>
            {
              pageIndex === 1 &&
              <ChooseAccounts setPageIndex={setPageIndex} />
            }
            {
              pageIndex === 2 &&
              <Adjustment setPageIndex={setPageIndex} />
            }
            {
              pageIndex === 3 &&
              <FillUpTheData setPageIndex={setPageIndex} />
            }
            {
              pageIndex === 4 &&
              <PreviewAndConfirm setPageIndex={setPageIndex} />
            }
            <div className="pt-20  block" />
          </div>
        </div>
      </div>
      <div className="w-full h-screen relative overflow-hidden bg-white">
        <img src={cover} alt="cover" className="absolute inset-0 w-full h-full object-cover blur-2xl" />
        <div className="w-full h-full absolute inset-0 bg-black opacity-15" />
        <div className="flex items-center justify-center w-full h-full z-50 bg-white">
          <div onClick={() => redirect(pathnames.content)} className="absolute right-0 top-0">
            <Circlebtn icon={<RxCross2 />} className="bg-white w-8 h-8 absolute right-4 top-4" />
          </div>
          <div className="w-[402px] h-[490px] rounded-2xl bg-white z-50">

          </div>
        </div>
      </div>
    </section>
  );
};

export default SchedulePublish;